/**
 * SearchFieldsActionStore binds to SearchFieldsActions so that whenever the user changes any of the search sidebar's
 * widgets, SearchFieldsActionStore receives it and propagates the changes to <SearchInputBoxContainer/> so that it
 * can clear the search term if necessary
 */
import alt from 'components/Dispatcher';
import immutable from 'immutable';
import immutableStore from 'alt-utils/lib/ImmutableUtil';

import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import SearchFieldsActions from 'actions/search/SearchFieldsActions';
import SearchInputActions from 'actions/search/SearchInputActions';
import Utils from 'stores/Utils';

@immutableStore
class SearchFieldsActionStore {
  constructor() {
    this.state = immutable.Map({
      // `menuItemsRemoved` keeps track of the `menuItem(s)` whose search sidebar has been updated. When this variable
      // changes according to user actions, SearchInputBox.props.searchTerm might be cleared / removed if necessary
      menuItemsStatus: immutable.Map(),
      // `shouldClearSearchTerm` keeps track of when the user clicks the "Clear Search" button
      shouldClearSearchTerm: false,
    });
    this.bindActions(SearchFieldsActions);
    this.bindActions(SearchInputActions);
    this.bindActions(ManagerDashboardActions);
    this.utils = new Utils();
  }

  /** Inform the store's listeners that the search term should be cleared and the search-type should be reset to "All" */
  onClearSearchInputValue() {
    const state = this.state.set('shouldClearSearchTerm', true);
    this.setState(state);
  }

  /** Since the search term has been cleared and the search-type has been reset, reset
   * this.state.get('shouldClearSearchTerm') back to false
   */
  onClearShouldClearSearchTerm() {
    const state = this.state.set('shouldClearSearchTerm', false);
    this.setState(state);
  }

  /**
   * restore a previously saved search state
   * @param newState
   */
  onResetSearch(newState) {
    this.setState(newState.searchFieldsActionStoreState);
  }

  /**
   * Update this.state.get('menuItemsRemoved') using `args`
   * @param args {Array} [widgetType, toggled, searchField]
   */
  onUpdateSearchWidgetToggleState(args) {
    const [, toggled, searchField] = args;
    if (!toggled) {
      const miPrimaryText = this.utils.menuItemPrimaryTextFromSearchField(searchField);
      const state = this.state.setIn(['menuItemsStatus', miPrimaryText], {
        removed: true,
      });
      this.setState(state);
    }
  }

  /**
   * Update this.state.get('menuItemsRemoved') using `args`
   * @param args {Array} [searchField, value]
   */
  onRemoveStringSearchFieldSelectedValue(args) {
    const [field] = args;
    const miPrimaryText = this.utils.menuItemPrimaryTextFromSearchField(field);
    const state = this.state.setIn(['menuItemsStatus', miPrimaryText], {
      removed: true,
    });
    this.setState(state);
  }

  /**
   * Delete the `status` object attached to a menuItem within `this.state.get('menuItemsStatus')` so that it won't
   * affect SearchInputBox.props.searchTerm anymore atm
   * @param miPrimaryText Menu item's primary text
   */
  onClearMenuItemStatus(miPrimaryText) {
    const state = this.state.deleteIn(['menuItemsStatus', miPrimaryText]);
    this.setState(state);
  }
}

export default alt.createStore(SearchFieldsActionStore, 'SearchFieldsActionStore');
